
import { Component, ModelSync, Prop, Vue } from 'vue-property-decorator'
import CancelButton from '../buttons/CancelButton.vue'
import DangerButton from '../buttons/DangerButton.vue'
import DangerDialog from '../dialogs/DangerDialog.vue'
import { Booking } from "@/api/dtos/Booking.schema";

@Component({
  components: {
    CancelButton,
    DangerButton,
    DangerDialog
  }
})
export default class RefundBookingDialog extends Vue {
  @ModelSync('value', 'input')
  show!: boolean

  @Prop()
  booking!: Booking;

  refundMessage: null | string = null
  shouldRefund = false
  refundAmount = 0

  onCancel () {
    this.show = false
    this.$emit('cancel')
  }

  onConfirm () {
    this.show = false
    this.$emit('confirm', this.booking)
  }
}
